import EventBus, { BaseEvent } from '../utils/EventBus';

export default new EventBus();

export class EscapePressed extends BaseEvent {
}